module.exports = {
      id: "protichinta-usage",
      viewBox: "0 0 192 60",
      url: "/" + "sprite-94c0c4e617ccd395a266f9fdfc4a2687.svg#protichinta",
      toString: function () {
        return this.url;
      }
    }